import { render, staticRenderFns } from "./ProductPreviewGridItem.vue?vue&type=template&id=fbe6f02c&scoped=true&"
import script from "./ProductPreviewGridItem.vue?vue&type=script&lang=js&"
export * from "./ProductPreviewGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductPreviewGridItem.vue?vue&type=style&index=0&id=fbe6f02c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe6f02c",
  null
  
)

export default component.exports